import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MessageModule } from 'primeng/message';

@Component({
    selector: 'message',
    standalone: true,
    imports: [MessageModule, TranslateModule],
    templateUrl: './message.component.html',
    styleUrl: './message.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageComponent {
    id = input<string>('');

    severity = input<'success' | 'info' | 'warn' | 'error' | 'secondary'>('info');
    text = input<string>('');

    hideIcon = input<boolean>(false);
    closeable = input<boolean>(false);
    variant = input<'default' | 'outlined'>('default');

    icon = computed(() => {
        if (this.hideIcon()) {
            return '';
        }

        switch (this.severity()) {
            case 'success':
                return 'fa-regular fa-square-check';
            case 'info':
                return 'fa-regular fa-circle-info';
            case 'warn':
                return 'fa-regular fa-triangle-exclamation';
            case 'error':
                return 'fa-regular fa-do-not-enter';
            case 'secondary':
                return 'fa-regular fa-megaphone';
        }
    });

    onClose = output<void>();
}
